function globalCustomStarRating(ratingElement, selector) {
  if (ratingElement) {
    return new Promise((resolve) => {
      if (ratingElement.querySelector(selector)) {
        return resolve(ratingElement.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (ratingElement.querySelector(selector)) {
          resolve(ratingElement.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}

try {
  const pdpStarRating = document.querySelector('#trusted_shops_easy_integration_product_review_list_extension_PVeWA7');
  globalCustomStarRating(pdpStarRating, 'etrusted-star-extension').then((element) => {
    const shadowRoot = element.shadowRoot;
    const getCurrentRating = Number.parseFloat(shadowRoot.querySelector('etrusted-rl-star-rating').attributes.rating.nodeValue);
    const grade = shadowRoot.querySelector('.grade');
    const count = shadowRoot.querySelector('.count');

    const style = new CSSStyleSheet;

    style.replaceSync(`
      .star-rating {
        gap: 0 !important;
      }
      .grade, .count { 
        font-size: 14px !important;
        line-height: normal !important;
        font-family: 'Montserrat', sans-serif !important;
        color: #003f22 !important;
        font-weight: 600 !important;
      }

      .count {
        font-size: 13px !important;
      }
    `);

    shadowRoot.adoptedStyleSheets.push(style)

    grade.textContent = getCurrentRating.toFixed(1);
    count.textContent = 'Sterne';
  });
} catch (error) {
  console.log(error);
}

try {
  const getAllRatingsElements = document.querySelectorAll('[data-etrusted-widget-id]');

  getAllRatingsElements.forEach(ratingElement => {
    console.log(ratingElement.shadowRoot);

    globalCustomStarRating(ratingElement, 'etrusted-trusted-stars-service-widget').then((element) => {
      console.log(element.shadowRoot, element);
    });
  })
} catch (error) {
  console.log(error)
}

